import { Checkbox, Flex, FlexProps } from "@chakra-ui/react";
import { Icon } from "./icon";
import { Text } from "./Text";
import React, { useMemo, useState } from "react";

interface DisplayTaxIDProps extends FlexProps {
  value: string;
  label?: string;
  maskByDefault?: boolean;
}

export const DisplayTaxID = ({
  value,
  label = "SSN",
  maskByDefault = true,
  ...rest
}: DisplayTaxIDProps) => {
  const [masked, setMasked] = useState<boolean>(maskByDefault);
  const text = useMemo(() => {
    if (masked && value) {
      const last4 = value.slice(-4);

      return `*****${last4}`;
    }

    return value;
  }, [masked]);

  return (
    <Flex direction="column" mt="1" {...rest}>
      <Text mb="0">
        {label}: {text}
      </Text>
      <Checkbox
        onChange={() => {
          setMasked((prev) => !prev);
        }}
        checked={!masked}>
        Show {label}
      </Checkbox>
    </Flex>
  );
};
